import React from 'react'
import useIsInViewport from 'use-is-in-viewport'

import Container from '../../../utils/Container'
import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Button from '../../../elements/buttons/Button'
import mySelf from '../../../../medias/images/mySelf.png'
import ProgressiveImg from '../../../elements/images/ProgressiveImg'
import Services from './Services';

const MySelf = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section 
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv" } relative  mt-32 md:mt-44 bg-custom-gray py-28 md:py-14 md:pt-52`}
		>
			<Services classe="hidden md:block" />

			<Container classe="">
				<div className="md:hidden mb-4 flex flex-col items-center ">
					<Heading2><span className="uppercase">à</span> propos</Heading2>
					<Heading3 classe="text-center md:text-left">Optez pour une traduction de qualité</Heading3>
				</div>
				<div className="flex  flex-col flex-col-reverse md:flex-row md:space-x-10 items-center">
					<div>
						<div className="hidden md:block mb-10">
							<Heading2><span className="uppercase">à</span> propos</Heading2>
							<Heading3>Optez pour une traduction de qualité</Heading3>
						</div>
						<Paragraph>
							Je suis une traductrice professionnelle de langue maternelle <b>française</b> et <b>anglaise</b>,
							ayant une maîtrise en <b>Espagnol</b>. Vous pouvez être rassuré que mes compétences et mon respect d'autrui vous serviront.
						</Paragraph>
						<Paragraph classe="mt-3">
							N'hésitez pas à vérifier tous mes réseaux sociaux pour vous assurer qu'en plus d'être professionnelle, je suis aussi <b>fiable</b> et qu'il est facile de travailler avec moi. 
						</Paragraph>

						<div className="flex justify-center md:justify-start">
							<Button
								link="/about"
								classe="mt-8"
							>
								En savoir plus
							</Button>
						</div>
					</div>

					<div>
						<ProgressiveImg 
							src={mySelf}
							alt="une redactrice sur son ordinateur"
							classe="w-64 inline-block my-5 md:my-0 sm:w-96 md:w-150"
						/>
					</div>
				</div>
			</Container>
		</section>
	)
}

export default MySelf